import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, permission }) {
  const { status, hasPerm } = useAuth();
  if (status === "loading") {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-black text-zinc-400">
        <div className="flex flex-col items-center gap-3" data-testid="app-loading">
          <div className="h-10 w-10 rounded-full border-2 border-violet-500 border-t-transparent animate-spin" />
          <div className="tiny-label">Booting NightOps…</div>
        </div>
      </div>
    );
  }
  if (status !== "authed") return <Navigate to="/login" replace />;
  if (permission && !hasPerm(permission)) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-black text-white">
        <div className="max-w-md text-center panel-elevated p-10" data-testid="permission-denied">
          <div className="tiny-label text-red-400">Access denied</div>
          <h2 className="mt-3 text-2xl font-bold">You don't have permission</h2>
          <p className="mt-2 text-zinc-400">Missing: <code className="mono text-zinc-300">{permission}</code></p>
        </div>
      </div>
    );
  }
  return children;
}
